<template>
  <div v-if="isClient" ref="shadowContainer" />
  <div v-else class="wysiwyg-preview" v-html="htmlCode" />
</template>

<script>
/* eslint-disable import/no-webpack-loader-syntax */
import { defineComponent, ref, onMounted, watch, nextTick } from 'vue'
import ckEditorStyle from '!!raw-loader!./ck-editor.css'
/* eslint-enable import/no-webpack-loader-syntax */

export default defineComponent({
  name: 'WysiwygPreview',
  props: {
    htmlCode: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  setup (props) {
    const isClient = ref(false)
    const shadowContainer = ref(null)

    const createElementFromHTML = (htmlString) => {
      htmlString = htmlString || '<div></div>'
      const div = document.createElement('div')
      div.innerHTML = `
        <style>
          ${ckEditorStyle}
        </style>
        <div class="ck-content">
          ${htmlString.trim()}
        </div>
      `
      return div
    }

    const handleRenderHTML = () => {
      const container = shadowContainer.value
      const node = createElementFromHTML(props.htmlCode)

      if (!node) {
        throw new Error('建立 Node 失敗')
      }

      if (!container) return

      // 清掉原有內容
      while (container.firstChild) {
        container.removeChild(container.firstChild)
      }

      // 建立 Shadow DOM
      if (!container.shadowRoot) {
        container.attachShadow({ mode: 'open' })
      }

      if (container.shadowRoot) {
        container.shadowRoot.innerHTML = ''
        container.shadowRoot.appendChild(node)
      }
    }

    onMounted(() => {
      isClient.value = true

      watch(
        () => props.htmlCode,
        async () => {
          await nextTick()
          handleRenderHTML()
        },
        { immediate: true }
      )
    })

    return {
      isClient,
      shadowContainer
    }
  }
})
</script>

<style scoped>
.wysiwyg-preview {
  line-height: 1.6;
  font-size: 15px;
}

.wysiwyg-preview img {
  max-width: 100%;
  height: auto;
  display: block;
}
</style>
